type CheckProps = {
  color?: string
  size?: number
  style?: preact.JSX.CSSProperties
}

export const Check = function Check({ color = "#000", size = 80, style }: CheckProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 80 80" fill="none" style={style}>
      <path
        fill={color}
        d="M78.049,19.015L29.458,67.606c-0.428,0.428-1.121,0.428-1.548,0L0.32,40.015c-0.427-0.426-0.427-1.119,0-1.547l6.704-6.704c0.428-0.427,1.121-0.427,1.548,0l20.113,20.112l41.113-41.113c0.429-0.427,1.12-0.427,1.548,0l6.703,6.704C78.477,17.894,78.477,18.586,78.049,19.015z"
      />
    </svg>
  )
}
